import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const CustomerDocumentInput = () => {
  const { documentId = '' } = useParams();
  const decodedId = documentId ? atob(documentId) : documentId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'customerDocument';

  useEffect(() => {
    if (documentId) {
      setIsEditing(true);
      fetchDocumentDetails();
    }
  }, [documentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDocumentDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customerDocument}${id}/`, { headers });
      const d = response.data;
      setFormData({
        activity: d.activity?.id ?? d.activity,
        file: d.file,
      });
    } catch (error) {
      console.error('Error fetching document details:', error);
    }
  };

  const documentFields = [
    {
      name: 'activity', label: 'Activity', type: 'async-select', required: true,
      endpoint: API_ROUTES.customerActivity,
      getOptionLabel: (a) => a.subject,
    },
    { name: 'file', label: 'File', type: 'file', required: !isEditing },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Customer Document' : 'Upload Customer Document'}</h1>
      <FormComponent fields={documentFields} initialFormData={formData} route={route} cancelPath="/customer/document/list" />
    </div>
  );
};

export default CustomerDocumentInput;
